import { render, staticRenderFns } from "./OverlayRestart.vue?vue&type=template&id=cb1bdf0e&scoped=true"
import script from "./OverlayRestart.vue?vue&type=script&lang=js"
export * from "./OverlayRestart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1bdf0e",
  null
  
)

export default component.exports